export default {
  exhibitors: [],
  events: [],
  individual: {},
  expo: {},
  ajaxCallsInProgress: 0,
  synced: false
};
